const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpVggGreutherFrth2017(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 791.08,
    height: 791.08,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5933.08 2966.54C5933.08 1328.16 4604.92 0 2966.54 0 1328.17 0 0 1328.16 0 2966.54c0 1638.37 1328.17 2966.54 2966.54 2966.54 1638.38 0 2966.54-1328.17 2966.54-2966.54",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 791.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.742 2966.52c0 1560.12 1264.688 2824.81 2824.808 2824.81 1560.11 0 2824.8-1264.69 2824.8-2824.81 0-1560.11-1264.69-2824.801-2824.8-2824.801-1560.12 0-2824.808 1264.691-2824.808 2824.801zm288.516 0c0-1400.78 1135.512-2536.278 2536.292-2536.278S5502.84 1565.74 5502.84 2966.52c0 1400.78-1135.51 2536.29-2536.29 2536.29S430.258 4367.3 430.258 2966.52",
    style: {
      fill: "#2fa641",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 791.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2589.04 3197.35c29.06 38.61 54.53 76.82-146.86 265.87-247.34 232.21-662.98 649.95-396.82 1148.66 180.67 338.51 520.14 271.18 662.29 198.2 98.22-50.42 333.45-204.46 560.01-38.2 252.73 185.47 627.56 46.52 709.08-175.9 79.55-217.04 103.65-556.43-219.53-892.76-323.18-336.32-504.98-470.47-348.65-534.52 59.35-24.33 108.87 56.53 188.18 152.28 133.18 160.76 365.92 321.6 670 462.5 322.65 149.5 894.57-46.98 655-752.5-74.94-220.69-86.87-467.58-7.5-617.5 112.5-212.5 90-580-187.5-692.5-272.71-110.56-595.41-81.43-790.43 59.06-195.02 140.49-496.33 573.14-550.45 643.18-54.12 70.04-112.24 178.7-249.55 207.76 25.88-210.94-25.47-511.84-38.2-588.65-12.74-76.82-102.7-332.74-201.8-544.09-99.1-211.34-102.29-214.53-243.19-236.81-140.9-22.29-424.51-100.94-473.63-121.39-35.32-14.71-134.53 12.32-160 54.12s22.29 76.43 60.9 95.92c38.61 19.51 768.16 464.49 771.34 1302.69 0 130.94-70.44 83.19-128.16 28.66-57.71-54.53-182.69-150.84-553.63-608.17-370.94-457.3-893.2-304.78-956.82-281.38-238.393 87.68-369.729 449.08-255.913 694.53 107.993 232.91 169.593 387.77 95.913 572.73-38.2 95.92-156.405 345.48-38.2 569.56 118.2 224.08 435.71 392 854.12 156.81 256.33-144.08 400.41-329.15 486.77-422.28 86.37-93.15 163.19-176.33 233.23-105.88",
    style: {
      fill: "#2fa641",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 791.08)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpVggGreutherFrth2017);
export default __webpack_public_path__ + "static/media/SpVgg_Greuther_Fürth_2017.d1f55b58c3c22ae534b3de8fc3595957.svg";
export { ForwardRef as ReactComponent };